export default __webpack_public_path__ + "static/media/win_one.f6700ba1.svg";